<ng-container *ngIf="isLoaded"><div [innerHtml]="content"></div></ng-container>
